export default {

  /**
   * Vai trò người dùng
   */
  UserRoleType: {
    Chief: 'Trưởng bộ phận',
    Deputy: 'Phó bộ phận',
    Employee: 'Chuyên viên',
  },

  /**
   * Loại cán bộ
   */
  EmployeeType: {
    Executive: 'Cán bộ',
    PublicServant: 'Công chức',
    Official: 'Viên chức',
    ContractLabour: 'Lao động hợp đồng',
    HDKCTX: 'Người hoạt động KCT xã',
    HDKCTT: 'Người hoạt động KCT thôn',
    LDCTCHDT: 'Lãnh đạo chuyên trách tại các hội đặc thù',
    Other: 'Khác',
  },

  /**
   * Trạng thái làm việc của cá nhân
   * tương đương enum bên QLCB
   */
  EmployeeStatus: {
    Working: "Đang làm việc",
    ForeignWork: "Đang công tác nước ngoài",
    Retiring: "Nghỉ hưu",
    LeaveJob: "Nghỉ việc",
    OutOfSystem: 'Điều chuyển đi',
  },
  
  /**
   * Trạng thái của form
   */
  FormState: {
    Add: 'Thêm',
    View: 'Xem',
    Edit: 'Sửa',
    Duplicate: 'Thêm',
    QuickAdd: 'Thêm nhanh'
  },
  /**
   * Giới tính
   */
  Gender: {
    Female: 'Nữ',
    Male: 'Nam',
    Other: 'Khác'
  },
  InDebt: {
    Debt: 'Dư nợ',
    ExcessYes: 'Dư có'
  },
  /**
   * toán tử filter
   */
  FilterOperator: {
    Contains: 'Chứa',
    Notcontains: 'Không chứa',
    StartsWith: 'Bắt đầu với',
    EndsWith: 'Kết thúc với',
    Null: '(Trống)',
    NotNull: '(Không trống)',
    Equals: 'Bằng',
    NotEquals: 'Khác',
    GreaterThan: 'Lớn hơn',
    GreaterThanEquals: 'Lớn hơn hoặc bằng',
    LessThan: 'Nhỏ hơn',
    LessThanEquals: 'Nhỏ hơn hoặc bằng',
    Between: 'Trong khoảng'
  },

  OrganizationUnitType: {
    Corporations: 'Tổng công ty',
    Group: 'Tập đoàn',
    Subsidiaries: 'Công ty con',
    Branch: 'Chi nhánh',
    Representative: 'Văn phòng đại điện',
    Office: 'Văn phòng',
    Center: 'Trung tâm',
    Department: 'Phòng ban',
    Team: 'NHóm/tổ/đội',
    Factory: 'Phân xưởng'
  },
  Period: {
    ThisDay: 'Hôm nay',
    ThisWeek: 'Tuần này',
    FirstWeekToPresent: 'Đầu tuần tới hiện tại',
    ThisMonth: 'Tháng này',
    FirstMonthToPresent: 'Đầu tháng tới hiện tại',
    ThisQuarter: 'Quý này',
    FirstQuarterToPresent: 'Đầu quý tới hiện tại',
    ThisYear: 'Năm nay',
    FirstYearToPresent: 'Đầu năm tới hiện tại',
    SixFirstMonth: 'Sáu tháng đầu năm',
    SixLastMonth: 'Sáu tháng cuối năm',
    January: 'Tháng 1',
    February: 'Tháng 2',
    March: 'Tháng 3',
    April: 'Tháng 4',
    May: 'Tháng 5',
    June: 'Tháng 6',
    July: 'Tháng 7',
    August: 'Tháng 8',
    September: 'Tháng 9',
    October: 'Tháng 10',
    November: 'Tháng 11',
    December: 'Tháng 12',
    FiscalI: 'Quý 1',
    FiscalII: 'Quý 2',
    FiscalIII: 'Quý 3',
    FiscalIV: 'Quý 4',
    Yesterday: 'Hôm qua',
    LastWeek: 'Tuần trước',
    LastMonth: 'Tháng trước',
    LastQuarter: 'Quý trước',
    LastYear: 'Năm trước',
    Tomorrow: 'Ngày mai',
    NextWeek: 'Tuần sau',
    NextMonth: 'Tháng sau',
    NextQuarter: 'Quý sau',
    NextYear: 'Năm sau',
    Custom: 'Tùy chọn'
  },
  Currency: {
    VND: 'VND',
    Dola: 'USD'
  },
  Pagination: {
    // Two: '2 bản ghi trên 1 trang',
    Ten: '10 bản ghi trên 1 trang',
    Twen: '20 bản ghi trên 1 trang',
    Thir: '30 bản ghi trên 1 trang',
    Fif: '50 bản ghi trên 1 trang',
    Hunder: '100 bản ghi trên 1 trang'
  },
  SalaryForm: {
    Coefficient: 'Hệ số',
    Amount: 'Số tiền'
  },
  ReportPeriod: {
    January: 'Tháng 01',
    February: 'Tháng 02',
    March: 'Tháng 03',
    April: 'Tháng 04',
    May: 'Tháng 05',
    June: 'Tháng 06',
    July: 'Tháng 07',
    August: 'Tháng 08',
    September: 'Tháng 09',
    October: 'Tháng 10',
    November: 'Tháng 11',
    December: 'Tháng 12',
    QuarterI: 'Quý I',
    QuarterII: 'Quý II',
    QuarterIII: 'Quý III',
    QuarterIV: 'Quý IV',
    FirtsHalfYear: '6 tháng đầu năm',
    SecondHalfYear: '6 tháng cuối năm',
    Year: 'Cả năm',
    ThisMonth: 'Tháng này',
    ThisQuarter: 'Quý này',
    Custom: 'Tùy chọn',
    ThisWeek : 'Tuần này',
    LastWeek : 'Tuần trước',
    LastMonth : 'Tháng trước',
    LastQuarter : 'Quý trước',
    ThisYear : 'Năm nay',
    LastYear : 'Năm trước'
  },
  /**
   * Kí hiệu tiền tệ
   */
  MoneySign: {
    NormalVND: 'đ',
    UpperCaseVND: 'Đ',
    Dola: '$',
    Eur: 'EUR',
    None: 'Không chọn'
  },
  /**
   * Ký tự ngăn cách
   */
  Separator: {
    Dot: '. (dấu chấm)',
    Comma: ', (dấu phẩy)'
  },
  /**
   * Định dạng số dương
   */
  PositiveFormat: {
    $n: '$n',
    '$ n': '$ n',
    n$: 'n$',
    'n $': 'n $'
  },
  /**
   * Định dạng số âm
   */
  NegativeFormat: {
    '($n)': '($n)',
    '-$n': '-$n',
    '$-n': '$-n',
    '$n-': '$n-',
    '(n$)': '(n$)',
    '-n $': '-n $',
    'n-$': 'n-$',
    'n $-': 'n $-',
    '-$ n': '-$ n',
    '$ n-': '$ n-',
    'n- $': 'n- $',
    '($ n)': '($ n)',
    '(n $)': '(n $)'
  },
  /**
   * Kí hiệu âm
   */
  NegativeSign: {
    '(n)': '(n)',
    '-n': '-n',
    '- n': '- n',
    'n-': 'n-',
    'n -': 'n -'
  },
  /**
   * Font chữ
   */
  FontFamily: {
    TimesNewRoman: 'Times New Roman',
    OpenSan: 'Open San',
    Arial: 'Arial',
    Tahoma: 'Tahoma',
    Cambria: 'Cambria',
    ArialNarrow: 'Arial Narrow'
  },
  /**
   * Kiểu chữ
   */
  FontStyle: {
    Regular: 'Regular',
    Bold: 'Bold',
    Italic: 'Italic',
    BoldItalic: 'Bold Italic'
  },
  /**
   * Mã lỗi Validate
   */
  ValidateCode: {
    Required: 'Nhập thiếu thông tin',
    EditVersion: 'Dữ liệu đã bị thay đổi bởi người dùng khác',
    Duplicate: 'Dữ liệu đã tồn tại trong hệ thống',
    Arise: 'Danh mục đã có phát sinh',
    System: 'Dữ liệu thuộc hệ thống'
  },

  MessageBoxType: {
    confirm_Info_Warning: 0,
    confirm_Yes_No: 1,
    confirm_Yes_No_Cancel: 2,
    confirm_Delete: 3,
    confirm_Close: 4,
    confirm_Cancel_Accept: 5
  },

  /**
   * Trạng thái validate của dòng nhập khẩu
   * NCPHUOC 28/07/2022
   */
  ImportValidateStatus: {
    Valid: 'Hợp lệ',
    DataExist: 'Dữ liệu đã tồn tại',
    NotValid: 'Không hợp lệ'
  },

  /**
   * Vai trò mặc định mặc định mang đi
   * NTTHANH1 13/04/2023
   */
  RoleCode: {
    AdminSystem: "Quản trị hệ thống",
    PerformETask: "Thực hiện Công việc"
  },

  /**
   * 3 loại việc mặc định mang đi
   * VDGiang 1/6/2023
   */
  TaskType: {
    UBNDPlan: 'Kế hoạch UBND',
    Arise: 'Phát sinh',
    OrganizationPlan: 'Kế hoạch đơn vị' 
  }
};
